/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IUserAdditionalHistory {
  id?: string;
  coffee?: string | null;
  tobacco?: string | null;
  alcohol?: string | null;
  sleepPatterns?: string | null;
  exercisePatterns?: string | null;
  seatbeltUse?: string | null;
  counseling?: string | null;
  hazardousActivities?: string | null;
  recreationalDrugs?: string | null;
  recentBreastExam?: string | null;
  recentMammogram?: string | null;
  recentGynocologicalExam?: string | null;
  recentRectalExam?: string | null;
  recentProstateExam?: string | null;
  recentPhysicalExam?: string | null;
  recentSigmoidoscopyColonoscopy?: string | null;
  recentEcg?: string | null;
  recentCardiacEcho?: string | null;
  recentRetinal?: string | null;
  recentFluvax?: string | null;
  recentPneuvax?: string | null;
  recentLdl?: string | null;
  recentHemoglobin?: string | null;
  recentPsa?: string | null;
  recentExamResults?: string | null;
  historyMother?: string | null;
  dcMother?: string | null;
  historyFather?: string | null;
  dcFather?: string | null;
  historySiblings?: string | null;
  dcSiblings?: string | null;
  historyOffspring?: string | null;
  dcOffspring?: string | null;
  historySpouse?: string | null;
  dcSpouse?: string | null;
  relativesCancer?: string | null;
  relativesTuberculosis?: string | null;
  relativesDiabetes?: string | null;
  relativesHighBloodPressure?: string | null;
  relativesHeartProblems?: string | null;
  relativesStroke?: string | null;
  relativesEpilepsy?: string | null;
  relativesMentalIllness?: string | null;
  relativesSuicide?: string | null;
  cataractSurgery?: number | null;
  tonsillectomy?: number | null;
  cholecystestomy?: number | null;
  heartSurgery?: number | null;
  hysterectomy?: number | null;
  herniaRepair?: number | null;
  hipReplacement?: number | null;
  kneeReplacement?: number | null;
  appendectomy?: number | null;
  tmDate?: number | null;
  name1?: string | null;
  value1?: string | null;
  name2?: string | null;
  value2?: string | null;
  additionalHistory?: string | null;
  exams?: string | null;
  usertext11?: string | null;
  usertext12?: string | null;
  usertext13?: string | null;
  usertext14?: string | null;
  usertext15?: string | null;
  usertext16?: string | null;
  usertext17?: string | null;
  usertext18?: string | null;
  usertext19?: string | null;
  usertext20?: string | null;
  usertext21?: string | null;
  usertext22?: string | null;
  usertext23?: string | null;
  usertext24?: string | null;
  usertext25?: string | null;
  usertext26?: string | null;
  usertext27?: string | null;
  usertext28?: string | null;
  usertext29?: string | null;
  usertext30?: string | null;
  userdate11?: number | null;
  userdate12?: number | null;
  userdate13?: number | null;
  userdate14?: number | null;
  userdate15?: number | null;
  userarea11?: string | null;
  userarea12?: string | null;
  timestampentry?: number;
  active?: boolean;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
  consultant?: IDoctor | null;
  glucoUser?: IGlucoUser;
}

export const defaultValue: Readonly<IUserAdditionalHistory> = {
  active: false,
};
